<template>
  <div>
    <b-modal id="modalEditClientClassification" ref="modalEditClientClassification" :title="$t('Client classification')" hide-footer size="lg">
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Test')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.test" aria-describedby="inputFeedbackTest" :state="editItem.test.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackTest"/>
        </b-form-group>
        <b-form-group :label="$t('Option-data')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="swohAddOptionData">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-table small striped hover :items="editItem['option-data']" :fields="optionDataFields">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click.stop="editOptionData(row)" id="transparent">
              <b-img :src='editImage'/>
            </b-button>
            <b-button size="sm" @click.stop="deleteOptionData(row)" id="transparent">
              <b-img :src='deleteImage'/>
            </b-button>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditClientClassification.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <modalOptionData
      :selectSubnet="selectSubnet"
      :editItem="editItem"
      :selectOptionData="selectOptionData"/>
  </div>
</template>

<script>
import modalOptionData from '@/pages/settings/DHCPv6/modalOptionData'

export default {
  components: {
    modalOptionData
  },
  props: {
    clientClassification: null,
    editItem: null,
    isEdit: null
  },
  data () {
    return {
      selectSubnet: {
        'isSubnet': false
      },
      selectOptionData: {
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      },
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      optionDataFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'code', label: this.$i18n.t('Code'), sortable: true},
        {key: 'space', label: this.$i18n.t('Space'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    async save () {
      if (!this.editItem.name || !this.validationName()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Full name'), 'Error')
        return
      }
      if (!this.editItem.test) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Test'), 'Error')
        return
      }

      let copy = JSON.parse(JSON.stringify(this.editItem))
      let DHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let clientClass = {
        'is_test_only': true,
        'loop_count_timeout': 35,
        'config': {}
      }
      for (let el of this.editItem['option-data']) {
        delete el.isEdit
        delete el.numOptionData
      }
      if (this.isEdit) {
        for (let el of this.clientClassification) {
          if (this.editItem.numClientClass === el.numClientClass) {
            el.name = this.editItem.name
            el.test = this.editItem.test
            el['option-data'] = this.editItem['option-data']
          }
        }
        DHCPv6.arguments.Dhcp6['client-classes'] = this.clientClassification
      } else {
        DHCPv6.arguments.Dhcp6['client-classes'].push(this.editItem)
      }
      clientClass.config = DHCPv6.arguments
      await this.$store.dispatch('Settings/SAVE_DHCPV6', clientClass).then(response => {
        if (response.data.result === 0) {
          clientClass.is_test_only = false
          let response = this.$store.dispatch('Settings/SAVE_DHCPV6', clientClass)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
              this.$refs.modalEditClientClassification.hide()
              this.$root.$emit('makeToasts')
            }
          })
        } else {
          this.editItem = copy
          this.$root.$emit('makeToasts', 'danger', response.data.text, 'Error')
        }
      })
    },
    swohAddOptionData () {
      this.selectOptionData = {
        'numOptionData': 0,
        'isEdit': false,
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      }
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    editOptionData (row) {
      this.selectOptionData = JSON.parse(JSON.stringify(row.item))
      this.selectOptionData.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    deleteOptionData (row) {
      this.editItem['option-data'] = this.editItem['option-data'].filter((value) => {
        return value !== row.item
      })
    },
    validationName () {
      if (this.editItem.name.length === 0) {
        return false
      }
      let strArray = this.editItem.name.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.editItem.name.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/clientClassification/editModal.vue